import { connect } from 'react-redux';
import Error       from './error.jsx';
import Errors      from '../../../errors';

export default connect(
    // mapStateToProps
    ( state ) => {
        return {
            errors: Errors.getByType( state, Errors.ERROR_CLIENT_FETCHCLIENTDATA ),
            authenticated: state.userData.authenticated
        };
    },
    // mapDispatchToProps
    {}
)( Error );
